import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { ScriptElementKind } from 'typescript';

export interface TileEventInterface {
    el: QuizAnswerTile;
    active: boolean;
    nextRoute: undefined|string;
}

@Component
export class QuizAnswerTile extends ThemeComponent {
    @Ref() tileData!: HTMLScriptElement;
    private _onChange = new SimpleEvent<TileEventInterface>();

    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        this.clickEvent();
    }

    clickEvent() {
        const getRoute = () => {
            const value = this.dataset.routeTarget;

            if(value === undefined) {
                return undefined;
            }

            if(value === '') {
                return undefined;
            }

            return value;
        };

        const dispatch = (active:boolean) => {
            const data:TileEventInterface = {
                el: this,
                active: active,
                nextRoute: getRoute()
            };

            this._onChange.dispatch(data);
        };

        this.$listen(this, 'click', () => {
            if(this.classList.contains('active')) {
                this.classList.remove('active');
                dispatch(false);
            } else {
                this.classList.add('active');
                dispatch(true);
            }
        });
    }

    public getData() {
        let data = null;

        try {
            data = JSON.parse(this.tileData.innerHTML);
        } catch(event) {
            data = null;
            this.$log.error('JSON parse error', {
                event
            });
        }

        return data;
    }
}
